<template>
  <dl class="rireki-detail mt-5">
    <!-- dtクリックで次のdd表示・表示切替 -->
    <dt class="is-active column_sp">
      <div class="style-d-flex">
        <span class="rireki-detail-info mr-5"
          ><span class="mr-3">注文日</span>{{ orderDate }}</span
        >
        <span class="rireki-detail-info mr-5"
          ><span class="mr-3">注文番号</span>{{ orderNo }}</span
        >
        <!-- 荷物お問い合せ詳細情報へ遷移 -->
        <span class="rireki-detail-info">
          <span class="mr-3">お問い合わせ番号</span>
          <a :href="inquiryURL" v-if="inquiryURL != ''" target="_blank">{{
            inquiryNo
          }}</a>
          <div v-else>{{ inquiryNo }}</div>
        </span>
      </div>
      <span>
        <button v-on:click="openInfo" v-show="infoHide">開く</button>
        <button v-on:click="openInfo" v-show="!infoHide">閉じる</button>
      </span>
    </dt>
    <dd id="T1" v-show="!infoHide">
      <div class="detail-cart border box-p-20 mb-5">
        <div class="d-flex py-3 border-bottom only_pc">
          <div class="shohin_group text-center"><p>商品</p></div>
          <div class="shohin_quantity text-center"><p>個数</p></div>
          <div class="shohin_price text-center"><p>価格</p></div>
        </div>
        <div id="CartList">
          <ul>
            <li
              v-for="(item, index) in items"
              :key="item.no"
              class="d-flex align-items-center border-bottom"
            >
              <div class="shohin_group d-flex align-items-center my-3">
                <p>{{ index + 1 }}</p>
                <img
                  :src="images[index]"
                  :alt="item.name"
                  @error="noImage(index)"
                  class="mx-4"
                />
                <p>{{ item.name }}</p>
              </div>
              <div class="shohin_quantity text-center my-3">
                <p>{{ item.count }}個</p>
              </div>
              <div class="shohin_price my-3">
                <p class="text-right">{{ item.price }}円</p>
              </div>
            </li>
          </ul>
        </div>
        <!-- 動的HTML生成部 カート合計 -->
        <div id="CartTotal">
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>小計</p></div>
            <div class="shohin_price text-right">
              <p>{{ subTotal }}円</p>
            </div>
          </div>
          <!-- 代金引換の場合のみ表示-->
          <div v-if="paymentType == '0'" class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>代金引換手数料</p></div>
            <div class="shohin_price text-right">
              <p>{{ shipping }}円</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>送料</p></div>
            <div class="shohin_price text-right">
              <p>{{ deliveryFee }}円</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>使用ポイント</p></div>
            <div class="shohin_price text-right">
              <p>{{usePoint}}ポイント</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>合計</p></div>
            <div class="shohin_price text-right">
              <p>{{ totalAmount }}円</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>付与ポイント</p></div>
            <div class="shohin_price text-right">
              <p>{{getPoint}}ポイント</p>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-cart border box-p-20 mb-5">
        <h2 class="text-left mb-5">お届け先住所</h2>
        <div class="form-member my-5">
          <div class="inner">
            <dl id="ShippingAddress">
              <!-- 動的HTML生成部 お届け先 -->
              <dt>
                <strong>{{ name }}</strong>
              </dt>
              <dd>
                住所：〒{{ zipCode }}&emsp;{{ address }}<br />電話：{{ tell }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="text-center mb-5">
        <div v-if="orderCode">
          <button
            v-on:click="cancel"
            v-if="cancelOK == 'True' && !payCode"
            id="putCart0"
          >
            この注文をキャンセルする
          </button>
        </div>
        <div v-else-if="cancelOK == 'True' && payCode"></div>
        <div v-else>
          <button v-on:click="putCart" v-if="cancelOK != 'True'" id="putCart0">
            この商品をカートに入れる
          </button>
        </div>
      </div>
    </dd>
  </dl>
</template>
<style scoped>
dl.rireki-detail dt .rireki-detail-info {
  display: flex;
}
dl.rireki-detail > dt {
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 12px 15px;
  margin-bottom: -1px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
dl.rireki-detail > dt > span.rireki-detail-info {
  margin-right: 3rem;
}
span.rireki-detail-info > span {
  font-weight: bold;
}
.rireki-detail > dd {
  display: none;
  margin-top: 20px;
  padding-bottom: 25px;
  text-align: justify;
}
.rireki-detail > dd:first-of-type {
  display: block;
}
@media screen and (min-width: 1px) and (max-width: 991px) {
  dl.rireki-detail dt div:first-child {
    flex-direction: column;
  }
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  dl.rireki-detail dt span button {
    margin-top: 3rem;
  }
}
</style>
<script>
import Message from "@/modules/Message";
import Request from "@/modules/Request";
let request = new Request();
export default {
  data() {
    return {
      orderDate: this.order.orderDate,
      orderNo: this.order.orderNo,
      inquiryNo: this.order.inquiryNo,
      inquiryURL: this.order.inquiryURL,
      paymentType: this.order.paymentType,
      subTotal: this.order.subTotal,
      deliveryFee: this.order.deliveryFee,
      shipping: this.order.shipping,
      items: this.order.items,
      name: this.order.name,
      zipCode: this.order.zipCode,
      address: this.order.address,
      tell: this.order.tell,
      cancelOK: this.order.cancelOK,
      orderCode: this.order.orderCode,
      payCode: this.order.payCode,
      usePoint: this.order.usePoint,
      getPoint: this.order.getPoint,
      totalAmount: (parseInt(this.order.totalAmount.replace(",", ""))-parseInt(this.order.usePoint)).toLocaleString(),
      infoHide: true,
      images: [],
    };
  },
  props: ["order"],
  mounted() {
    this.order.items.forEach((item) => {
      this.images.push(
        process.env.VUE_APP_CONTENTS_PRODUCT_HOME + item.no + "/thumb.jpg"
      );
    });
  },
  methods: {
    putCart() {
      let requestParams = request.createParams(
        "webMdlOrderHistory",
        "putCartFromHistory",
        [this.orderNo]
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (data.message != "") {
            Message.confirm().fire({
              title: data.message,
            });
          }
          this.$router.push("/cart");
        });
    },
    cancel() {
      Message.confirm()
        .fire({
          title: "注文を取り消します。よろしいですか？",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let requestParams = request.createParams(
              "webMdlOrderHistory",
              "putCancelOrder",
              [this.orderNo]
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                Message.success()
                  .fire({
                    title: data.msg,
                    position: "center",
                    showConfirmButton: true,
                    timer: null,
                    toast: false,
                  })
                  .then(() => {
                    this.$router.go("/histories");
                  });
              });
          }
        });
    },
    openInfo() {
      this.infoHide ? (this.infoHide = false) : (this.infoHide = true);
    },
    noImage(no) {
      // 画像の読み込みに失敗すればnoimage
      this.images[no] =
        process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
  },
};
</script>